(function(){
  function esc(value){
    return String(value || '').replace(/[&<>"']/g,function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
    });
  }

  function parseLine(line){
    var original = String(line || '').trim();
    if(!original) return null;
    var query = original;
    var qty = 1;
    var match;

    match = query.match(/^\s*(\d+)\s*(?:x|ea|each|pcs?|packs?|pk|bxs?|boxes|ct|ctn|cartons?)?\s+(.+)$/i);
    if(match){
      qty = parseInt(match[1],10) || 1;
      query = match[2].trim();
    } else {
      match = query.match(/^(.+?)\s*(?:x|qty|quantity|-)\s*(\d+)\s*$/i);
      if(match){
        query = match[1].trim();
        qty = parseInt(match[2],10) || 1;
      }
    }

    query = query.replace(/^sku[:#]?\s*/i,'').trim();
    return { query: query, qty: qty, original: original };
  }


  function normalizeText(value){
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
  }

  function localProductIndex(root){
    var script = root && root.querySelector('[data-shopping-product-index]');
    if(!script) return [];
    if(script.__afsParsedIndex) return script.__afsParsedIndex;
    try{
      script.__afsParsedIndex = JSON.parse(script.textContent || '[]').filter(function(p){ return p && p.variantId && p.available !== false; });
    } catch(e){
      script.__afsParsedIndex = [];
    }
    return script.__afsParsedIndex;
  }

  function scoreLocalProduct(product, query){
    var q = normalizeText(query);
    if(!q) return 0;
    var compactQ = q.replace(/ /g,'');
    var title = normalizeText(product.title);
    var sku = normalizeText(product.sku);
    var vendor = normalizeText(product.vendor);
    var terms = normalizeText(product.terms || (product.title + ' ' + product.vendor + ' ' + product.sku));
    var compactTerms = terms.replace(/ /g,'');
    var score = 0;
    if(sku && sku.replace(/ /g,'') === compactQ) score += 1000;
    if(title === q) score += 700;
    if(sku && sku.indexOf(q) !== -1) score += 520;
    if(title.indexOf(q) !== -1) score += 420;
    if(compactTerms.indexOf(compactQ) !== -1) score += 250;
    if(vendor && q.indexOf(vendor) !== -1) score += 50;
    q.split(' ').forEach(function(token){
      if(token.length < 2) return;
      if(terms.indexOf(token) !== -1) score += 24;
    });
    return score;
  }

  function findLocalProduct(root, query){
    var index = localProductIndex(root);
    if(!index.length) return null;
    var best = null;
    var bestScore = 0;
    for(var i=0;i<index.length;i++){
      var score = scoreLocalProduct(index[i], query);
      if(score > bestScore){
        bestScore = score;
        best = index[i];
      }
    }
    if(!best || bestScore < 40) return null;
    return {
      title: best.title || 'Matched product',
      url: best.url || '#',
      image: best.image || '',
      variantId: best.variantId,
      sku: best.sku || '',
      price: best.price,
      priceText: formatMoney(best.price)
    };
  }

  function formatMoney(cents){
    var n = Number(cents);
    if(!isFinite(n)) return '';
    return '$' + (n / 100).toFixed(2);
  }

  async function addToCart(variantId, qty){
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(qty) || 1 })
    });
    if(!res.ok){
      var text = await res.text();
      throw new Error(text || 'Could not add item');
    }
    return res.json();
  }

  function productJsonUrl(productUrl){
    if(!productUrl) return null;
    var path = productUrl;
    try { path = new URL(productUrl, window.location.origin).pathname; } catch(e) {}
    path = path.split('?')[0].replace(/\/$/, '');
    if(path.indexOf('/products/') === -1) return null;
    return path + '.js';
  }

  async function fetchFullProduct(productUrl){
    var url = productJsonUrl(productUrl);
    if(!url) return null;
    var res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if(!res.ok) return null;
    return res.json();
  }

  function normalizeProduct(suggestion, fullProduct){
    var p = fullProduct || suggestion;
    if(!p) return null;
    var variants = p.variants || [];
    var firstAvailable = variants.find(function(v){ return v.available !== false; }) || variants[0];
    if(!firstAvailable || !firstAvailable.id) return null;
    var price = firstAvailable.price || p.price || null;
    return {
      title: p.title || suggestion.title || 'Matched product',
      url: suggestion.url || (p.handle ? '/products/' + p.handle : '#'),
      image: (p.featured_image && (p.featured_image.src || p.featured_image)) || suggestion.image || '',
      variantId: firstAvailable.id,
      sku: firstAvailable.sku || suggestion.sku || '',
      price: price,
      priceText: formatMoney(price)
    };
  }

  async function suggestProduct(query){
    var params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '4');
    params.set('resources[options][unavailable_products]', 'last');
    params.set('resources[options][fields]', 'title,product_type,vendor,variants.title,variants.sku');

    var res = await fetch('/search/suggest.json?' + params.toString(), { headers: { 'Accept': 'application/json' } });
    if(!res.ok) throw new Error('Search failed');
    var data = await res.json();
    var products = data && data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
    if(!products.length) return null;

    var q = query.toLowerCase().replace(/[^a-z0-9]/g,'');
    var chosen = products[0];
    for(var i=0;i<products.length;i++){
      var candidateText = ((products[i].title || '') + ' ' + (products[i].sku || '') + ' ' + (products[i].vendor || '')).toLowerCase().replace(/[^a-z0-9]/g,'');
      if(candidateText.indexOf(q) !== -1 || q.indexOf(candidateText) !== -1){ chosen = products[i]; break; }
    }

    var full = await fetchFullProduct(chosen.url);
    return normalizeProduct(chosen, full);
  }

  async function runMatcher(root){
    var textarea = root.querySelector('[data-shopping-list-input]') || root.querySelector('textarea');
    var results = root.querySelector('[data-match-results]');
    if(!textarea || !results) return;

    results.innerHTML = '<div class="empty-state">Matching your list...</div>';
    var lines = textarea.value.split('\n').map(parseLine).filter(Boolean);
    if(!lines.length){
      results.innerHTML = '<div class="empty-state">Paste one item per line to start.</div>';
      return;
    }

    var html = '';
    for(var i=0;i<lines.length;i++){
      try{
        var product = findLocalProduct(root, lines[i].query) || await suggestProduct(lines[i].query);
        if(product){
          html += '<div class="match-row" data-variant-id="'+esc(product.variantId)+'" data-match-title="'+esc(product.title)+'" data-match-sku="'+esc(product.sku)+'" data-match-price="'+esc(product.priceText)+'" data-match-original="'+esc(lines[i].original)+'" data-match-url="'+esc(product.url)+'">' +
            '<div class="match-thumb">'+(product.image ? '<img src="'+esc(product.image)+'" alt="">' : '<span>SKU</span>')+'</div>' +
            '<div class="match-main"><b><a href="'+esc(product.url)+'">'+esc(product.title)+'</a></b><br><small>Matched from: '+esc(lines[i].original)+(product.sku ? ' · SKU '+esc(product.sku) : '')+'</small></div>' +
            '<div class="match-price">'+esc(product.priceText || 'Price unavailable')+'</div>' +
            '<input aria-label="Quantity" type="number" min="1" value="'+esc(lines[i].qty)+'">' +
            '<div class="match-buttons"><button class="btn" type="button" data-add-match>Add to cart</button><button class="btn secondary" type="button" data-list-quote-row>Request quote</button></div>' +
          '</div>';
        } else {
          html += '<div class="match-row is-unmatched" data-unmatched-original="'+esc(lines[i].original)+'">' +
            '<div class="match-main"><b>No match found</b><br><small>'+esc(lines[i].original)+' can be included in a quote request.</small></div>' +
            '<div class="match-price">Needs review</div>' +
            '<span></span>' +
            '<div class="match-buttons"><button class="btn secondary" type="button" data-list-quote-row>Request quote</button></div>' +
          '</div>';
        }
      } catch(err){
        html += '<div class="match-row is-unmatched" data-unmatched-original="'+esc(lines[i].original)+'">' +
          '<div class="match-main"><b>Search unavailable</b><br><small>'+esc(lines[i].original)+'</small></div>' +
          '<div class="match-price">Needs review</div>' +
          '<span></span>' +
          '<div class="match-buttons"><button class="btn secondary" type="button" data-list-quote-row>Request quote</button></div>' +
        '</div>';
      }
    }
    results.innerHTML = html || '<div class="empty-state">No matches found.</div>';
  }

  function buildQuoteBody(root, singleRow){
    var textarea = root.querySelector('[data-shopping-list-input]');
    var rows = singleRow ? [singleRow] : Array.prototype.slice.call(root.querySelectorAll('.match-row'));
    var lines = [];
    lines.push('Shopping list quote request');
    lines.push('');
    if(textarea && textarea.value.trim()){
      lines.push('Original pasted list:');
      lines.push(textarea.value.trim());
      lines.push('');
    }
    lines.push(singleRow ? 'Requested item:' : 'Matched / reviewed items:');
    rows.forEach(function(row){
      var qtyInput = row.querySelector('input[type="number"]');
      var qty = qtyInput ? qtyInput.value : '1';
      if(row.hasAttribute('data-variant-id')){
        lines.push('- Qty ' + qty + ' | ' + (row.getAttribute('data-match-title') || '') + (row.getAttribute('data-match-sku') ? ' | SKU ' + row.getAttribute('data-match-sku') : '') + (row.getAttribute('data-match-price') ? ' | Price ' + row.getAttribute('data-match-price') : '') + (row.getAttribute('data-match-url') ? ' | ' + window.location.origin + row.getAttribute('data-match-url') : ''));
      } else {
        lines.push('- Needs review | ' + (row.getAttribute('data-unmatched-original') || row.textContent.trim()));
      }
    });
    return lines.join('\n');
  }

  function openListQuote(root, singleRow){
    var modal = root.querySelector('[data-list-quote-modal]');
    if(!modal) return;
    var body = modal.querySelector('[data-list-quote-body]');
    if(body) body.value = buildQuoteBody(root, singleRow);
    modal.setAttribute('aria-hidden','false');
    modal.classList.add('is-open');
    document.documentElement.classList.add('pdp-modal-open');
  }

  function closeListQuote(el){
    var modal = el.closest('[data-list-quote-modal]');
    if(modal){
      modal.setAttribute('aria-hidden','true');
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('pdp-modal-open');
    }
  }

  document.addEventListener('click', async function(e){
    var toggle = e.target.closest('[data-mobile-menu-toggle]');
    if(toggle){
      var nav = document.getElementById('MainNav');
      if(nav){
        var open = !nav.classList.contains('is-open');
        nav.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var quoteOpen = e.target.closest('[data-open-quote-modal]');
    if(quoteOpen){
      var modal = document.querySelector('[data-quote-modal]');
      if(modal){ modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); }
      return;
    }

    var quoteClose = e.target.closest('[data-close-quote-modal]');
    if(quoteClose){
      var modalClose = quoteClose.closest('[data-quote-modal]');
      if(modalClose){ modalClose.classList.remove('is-open'); modalClose.setAttribute('aria-hidden','true'); }
      return;
    }

    var closeList = e.target.closest('[data-close-list-quote]');
    if(closeList){ closeListQuote(closeList); return; }

    var run = e.target.closest('[data-match-list]');
    if(run){
      var root = run.closest('[data-shopping-list]');
      if(root) await runMatcher(root);
      return;
    }

    var add = e.target.closest('[data-add-match]');
    if(add){
      var row = add.closest('[data-variant-id]');
      if(!row) return;
      add.disabled = true;
      add.textContent = 'Adding...';
      try{
        await addToCart(row.getAttribute('data-variant-id'), parseInt(row.querySelector('input').value,10) || 1);
        add.textContent = 'Added';
      } catch(err){
        add.textContent = 'Try again';
        add.disabled = false;
      }
      return;
    }

    var rowQuote = e.target.closest('[data-list-quote-row]');
    if(rowQuote){
      var rowRoot = rowQuote.closest('[data-shopping-list]');
      var rowForQuote = rowQuote.closest('.match-row');
      if(rowRoot) openListQuote(rowRoot, rowForQuote);
      return;
    }

    var quoteAll = e.target.closest('[data-list-quote-all]');
    if(quoteAll){
      var quoteRoot = quoteAll.closest('[data-shopping-list]');
      if(!quoteRoot) return;
      var existingRows = quoteRoot.querySelectorAll('.match-row');
      if(!existingRows.length){ await runMatcher(quoteRoot); }
      openListQuote(quoteRoot, null);
      return;
    }

    var addAll = e.target.closest('[data-add-all-matches]');
    if(addAll){
      var root2 = addAll.closest('[data-shopping-list]');
      if(!root2) return;
      var rows = Array.prototype.slice.call(root2.querySelectorAll('[data-variant-id]'));
      if(!rows.length){
        await runMatcher(root2);
        rows = Array.prototype.slice.call(root2.querySelectorAll('[data-variant-id]'));
      }
      if(!rows.length) return;
      addAll.disabled = true;
      addAll.textContent = 'Adding matched items...';
      try{
        for(var r=0;r<rows.length;r++){
          await addToCart(rows[r].getAttribute('data-variant-id'), parseInt(rows[r].querySelector('input').value,10) || 1);
        }
        window.location.href = '/cart';
      } catch(err){
        addAll.textContent = 'Some items failed';
        addAll.disabled = false;
      }
    }
  });
})();

/* AFS PDP gallery thumbnails: update the main product image when a thumbnail is clicked. */
(function(){
  function initPdpGallery(root){
    var scope = root || document;
    var galleries = scope.querySelectorAll('.pdp-gallery-panel');
    galleries.forEach(function(gallery){
      if(gallery.__afsPdpGalleryReady) return;
      gallery.__afsPdpGalleryReady = true;
      var mainImg = gallery.querySelector('.pdp-main-media img');
      var thumbs = gallery.querySelectorAll('[data-pdp-thumb], .pdp-thumb');
      if(!mainImg || !thumbs.length) return;

      thumbs.forEach(function(button){
        button.addEventListener('click', function(){
          var thumbImg = button.querySelector('img');
          var fullSrc = button.getAttribute('data-full-src') || button.getAttribute('data-large-src') || (thumbImg ? thumbImg.currentSrc || thumbImg.src : '');
          var alt = button.getAttribute('data-alt') || (thumbImg ? thumbImg.alt : '') || mainImg.alt || '';
          if(!fullSrc) return;

          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = fullSrc;
          mainImg.alt = alt;

          thumbs.forEach(function(other){
            other.classList.remove('active');
            other.setAttribute('aria-pressed','false');
          });
          button.classList.add('active');
          button.setAttribute('aria-pressed','true');
        });
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initPdpGallery(document); });
  } else {
    initPdpGallery(document);
  }
  document.addEventListener('shopify:section:load', function(event){ initPdpGallery(event.target); });
})();

/* AFS B2B suite: quantity steppers, cart auto-update, one-click reorder. */
(function(){
  var cartUpdateTimer = null;

  function scheduleCartUpdate(input){
    var form = input.closest('[data-afs-cart-form]');
    if(!form) return;
    if(cartUpdateTimer) clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(function(){
      if(form.requestSubmit){ form.requestSubmit(); } else { form.submit(); }
    }, 600);
  }

  document.addEventListener('click', function(e){
    var minus = e.target.closest('[data-afs-qty-minus]');
    var plus = e.target.closest('[data-afs-qty-plus]');
    if(!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-afs-qty]');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if(!input) return;
    e.preventDefault();
    var min = parseInt(input.min, 10);
    if(!isFinite(min)) min = 0;
    var value = parseInt(input.value, 10) || 0;
    value = plus ? value + 1 : value - 1;
    if(value < min) value = min;
    input.value = value;
    scheduleCartUpdate(input);
  });

  document.addEventListener('change', function(e){
    var input = e.target;
    if(!input.matches('[data-afs-qty] input[type="number"]')) return;
    scheduleCartUpdate(input);
  });

  document.addEventListener('click', async function(e){
    var btn = e.target.closest('[data-afs-reorder]');
    if(!btn) return;
    var items = [];
    try { items = JSON.parse(btn.getAttribute('data-afs-reorder') || '[]'); } catch(err){ items = []; }
    items = items.filter(function(item){ return item && item.id; });
    if(!items.length) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items.map(function(item){ return { id: Number(item.id), quantity: Number(item.qty) || 1 }; }) })
      });
      if(!res.ok) throw new Error('Reorder failed');
      window.location.href = '/cart';
    } catch(err){
      btn.textContent = 'Some items unavailable';
      setTimeout(function(){ btn.textContent = original; btn.disabled = false; }, 2000);
    }
  });
})();
